// extracted by mini-css-extract-plugin
module.exports = {"assistant-text-area":"styles-module__assistant-text-area___MuJV0"};